import * as React from 'react';
import {Table} from 'antd';
import {ColumnProps} from 'antd/lib/table';

import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import {ErrorAlert} from '../common/ErrorAlert';
import {ErrorResponse, InventoryTransportLetter, PageResponseEnvelope} from '../api/dtos/dtos';
import furoApi from '../api/FuroApi';
import locales from '../locales';
import * as tableUtils from '../utils/table-utils';
import {GridState, searchableSortableColumn, sortableColumn} from '../utils/table-utils';
import {formatDate} from '../utils/date-utils';

interface Props {
  onSelect: (letter: InventoryTransportLetter) => void;
}

interface State extends GridState<InventoryTransportLetter> {
  error?: ErrorResponse;
}

class InventoryTransportLetterSelector extends React.Component<Props, State> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  public state: State = {
    ...tableUtils.initialGridState(10),
    sortColumnKey: 'date',
    sortOrder: 'descend',
  };

  public componentDidMount() {
    this.reload();
  }

  public render() {
    const columns: Array<ColumnProps<InventoryTransportLetter>> = [
      searchableSortableColumn(locales.id, 'transportLetterNumber', this.state, this.renderTransportLetterNumberColumn),
      searchableSortableColumn(locales.company_name, 'partnerName', this.state, l => l.partner ? l.partner.name : ''),
      searchableSortableColumn(locales.incoming_invoice, 'invoiceNumber', this.state, l => l.incomingInvoice ? l.incomingInvoice.invoiceNumber : '-'),
      sortableColumn(locales.date, 'date', this.state, l => formatDate(l.date)),
      searchableSortableColumn(locales.responsible_user, 'responsibleUser', this.state, l => l.responsibleUser),
    ];

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <Table
          dataSource={this.state.data}
          columns={columns}
          rowKey={tableUtils.idRowKeyFn}
          bordered={true}
          size="small"
          pagination={tableUtils.defaultPaginationConfig(this.state)}
          onChange={tableUtils.handleOnGridChange(this.state, this.onGridChange)}
          scroll={{x: 1024}}
        />

        <ErrorAlert style={{marginTop: '16px'}} error={this.state.error}/>
      </>
    );
  }

  private renderTransportLetterNumberColumn = (letter: InventoryTransportLetter): React.ReactNode => {
    const onClick = () => this.props.onSelect(letter);
    return <a onClick={onClick}>{letter.transportLetterNumber}</a>;
  };

  private onGridChange = (newState: GridState<InventoryTransportLetter>) => {
    this.setState({...newState}, () => this.reload());
  };

  private reload = () => {
    const request = tableUtils.toGridRequest(this.state);
    const promise = furoApi.inventoryTransportLetters.getAll(request)
      .then(this.onReloadSuccess)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onReloadSuccess = (response: PageResponseEnvelope<InventoryTransportLetter>) => {
    this.setState({
      ...tableUtils.toGridState(response),
      error: undefined,
    });
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  };
}

export default InventoryTransportLetterSelector;




// WEBPACK FOOTER //
// ./src/inventory-stock-details/InventoryTransportLetterSelector.tsx